import { CSSProperties } from 'react';
import styled from '@emotion/styled';

export const CardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 8px;
    flex-direction: row;
    flex-shrink: 0;

    @media (max-width: 950px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export default {
    topContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px',
        flexShrink: 0
    },
    loadingContainer: {
        width: '100%',
        height: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: 80
    },
    loadingText: {
        marginTop: 16
    }
} as Record<string, CSSProperties>;
